export const environment = {
  fakeData: false,
  production: true,
  apiUrl: '/api-tracking/rest/',
  atInternetPageName : 'page_de_suivi',
  mapbox: {
    accessToken: 'pk.eyJ1IjoiY29saXNzaW1vLW1hcGJveCIsImEiOiJjbG1ldGJhbzUxem5yM2V0YzZscTY1MGlkIn0.PWDRjFTWabDmeKL0i8ZE1g'
  },
  deliveryRedirect: "https://www.laposte.fr/particulier/modification-livraison?code="
};
